import { writable } from 'svelte/store';
import appConfig from '../appConfig.js';

// JSAPI 4.x Extent object will be stored here
// which aids in syncing the extents of multipe MapViews
export const extentStore = writable(null);

// string of chosen storm type
export const stormStore = writable(null);

// object for chosen return period option
export const returnPeriodStore = writable(null);

// object for chosen Sea Level Rise (SLR) and Storm Surge (SS) option
export const slrYearStore = writable(null);

// array to hold urls for 360 photo iframes in the footer
export const photos360UrlsStore = writable([]);

export const criticalFacilitiesLayersStore = writable({
  visible: false,
  layers: [],
  layerViews: [],
  visuallyFilteredCategories: {
    'School': true,
    'Health Facility': true,
    'Police Department': true,
    'EMS/Fire Station': true,
    'MBTA Station': true
  }
});

// create an object of configued keys with empty (null) values
const categoriesObject = {};
appConfig.criticalFacilitiesLayer.categories.forEach(categoryName => {
  categoriesObject[categoryName] = null;
});
// object to hold summary stats about critical infrastructure facilities
export const criticalFacilitiesStatsStore = writable(categoriesObject);

// Boolean for side-by-side comparison state
export const sideBySideComparisonStore = writable(false);

// object for secondary comparison Sea Level Rise (SLR) and Storm Surge (SS) option
export const secondarySlrYearStore = writable(null);

// Which display to show
//export const whichDisplay = writable('noaction'); 
export const whichDisplay = writable('adaptationmeasures');

